import { render, staticRenderFns } from "./RoomManagementIcon.vue?vue&type=template&id=0923ee87"
import script from "./RoomManagementIcon.vue?vue&type=script&lang=js"
export * from "./RoomManagementIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports